import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getSectionsFormAction } from '../actions';

const {
  useLoaderData: useSectionsFormLoaderData,
  useLoader: useSectionsFormLoader,
  LoaderConsumerSimple,
  LoaderConsumer: SectionsFormConsumer,
  LoaderProvider,
} = createLoaderImp({
  action: getSectionsFormAction,
});

function SectionsFormLoader({
  children,
  ...props
}: Readonly<Parameters<typeof LoaderProvider>[0]>) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  SectionsFormLoader,
  SectionsFormConsumer,
  useSectionsFormLoader,
  useSectionsFormLoaderData,
};
